import { number_format } from '@/api/filter';
export const config = {
    data() {
        return {
            searchParams: {},
            columns: []
        };
    },
    methods: {
        getColumns() {
            let vm = this;
            this.columns = [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: '80'
                },
                {
                    title: '保单号',
                    key: 'policyNo',
                    minWidth: 180,
                    align: 'center',
                },
                {
                    title: '保险公司',
                    key: 'companyName',
                    minWidth: 180,
                    align: 'center'
                },
                {
                    title: '产品',
                    key: 'productName',
                    minWidth: 180,
                    align: 'center',
                    tooltip: true
                },
                {
                    title: '险种名称',
                    key: 'insuranceName',
                    minWidth: 180,
                    align: 'center',
                },
                {
                    title: this.queryParams.type == 1 ? '承保保费（元）' : '实收保费（元）',
                    key: 'fee',
                    minWidth: 140,
                    align: 'center',
                    render(h,params){
                        const row = params.row;
                        return <span>{number_format(row.fee ,2)}</span>
                    }
                },
                {
                    title: '保单状态',
                    key: 'policyStatus',
                    minWidth: 140,
                    align: 'center',
                    render(h, params) {
                        const row = params.row;
                        let data = '';
                        if (row.policyStatus == 1) {
                            data = '已承保';
                        } else if (row.policyStatus == -1) {
                            data = '已退保';
                        } else if (row.policyStatus == 0) {
                            data = '已终止';
                        } else if (row.policyStatus == 2) {
                            data = '已中止';
                        }
                        return <span>{data}</span>;
                    }
                },
                {
                    title: '承保时间',
                    key: 'payTime',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                        const payTime = params.row.payTime && params.row.payTime.substring(0, 10);
                        return <span>{payTime}</span>;
                    }
                },
                {
                    title: '生效日期',
                    key: 'startTime',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                        const startTime = params.row.startTime && params.row.startTime.substring(0, 10);
                        return <span>{startTime}</span>;
                    }
                },
                {
                    title: '出单团队',
                    key: 'groupName',
                    minWidth: 180,
                    align: 'center',
                },
                {
                    title: '出单人',
                    key: 'salesManName',
                    minWidth: 140,
                    align: 'center'
                }
            ];
            if (this.queryParams.type == 2 || this.queryParams.type == 3) {
                //实收显示续费时间 应续日期
                let idx = this.columns.findIndex(i => i.key == 'companyName');
                this.columns.splice(idx, 0, {
                    title: '续费时间',
                    key: 'serverEndDate',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                        const serverEndDate = params.row.serverEndDate && params.row.serverEndDate.substring(0, 10);
                        return <span>{serverEndDate}</span>;
                    }
                });
                idx = this.columns.findIndex(i => i.key == 'orgName');
                this.columns.splice(idx, 0, ...[{
                    title: '应续日期',
                    key: 'needPayDate',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                        const needPayDate = params.row.needPayDate && params.row.needPayDate.substring(0, 10);
                        return <span>{needPayDate}</span>;
                    }
                },{
                    title: '交费方式',
                    key: 'payTypeDesc',
                    minWidth: 140,
                    align: 'center'
                },{
                    title: '交费期数',
                    key: 'curRenewalTimes',
                    minWidth: 140,
                    align: 'center'
                }]);
            }
            if (this.queryParams.owerType == 4) {
                // owerType: '4', // 1、保司2、通道 3、机构 4、渠道

                this.columns.find(item => item.key == 'orgName').key = 'topOrgName';
                this.columns.splice(this.columns.length -1, 0, {
                    title: '出单渠道',
                    key: 'orgName',
                    minWidth: 180,
                    align: 'center'
                });
                let idx = ''
                idx = this.columns.findIndex(item => item.key == 'groupName')
                this.columns.splice(idx, 1);
                idx = this.columns.findIndex(item => item.key == 'salesManName')
                this.columns.splice(idx, 1);
            }
        }
    }
};
